<template>
  <div>
    <div class="flex items-center justify-between mb-2">
      <div class="flex items-center gap-1">
        <b-button
          variant="primary"
          size="sm"
          class="mr-1 rounded-lg p-0"
          @click="goBack"
        >
          <feather-icon
            size="2x"
            icon="ChevronLeftIcon"
          />
        </b-button>
        <h3 class="text-black font-semibold mb-0">
          Detail Tagihan
        </h3>
      </div>
      <div>
        <b-badge
          v-if="isBeenPaid && !isLoading && !isError"
          variant="light-success"
          class="px-2 py-1"
          pill
        >
          Sudah Dibayar
        </b-badge>
      </div>
    </div>
    <div class="detail">
      <div
        v-if="isError"
        class="text-center text-[#2c2c2c] bg-[#f0f0f0] rounded-lg p-4"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
          alt="Komerce"
          class="w-[100px] h-[100px] mx-auto mb-2"
        >
        <p class="mb-0">
          Mohon maaf, rincian pembayaran low moving stock belum tersedia.</p>
        <p class="mb-0">
          Silahkan hubungi admin untuk informasi lebih lanjut.</p>
      </div>
      <div
        v-if="!isError"
        :class="isLoading ? 'table-container__loading animate-pulse' : 'table-container'"
      >
        <table
          v-if="!isLoading"
          class="table b-table"
        >
          <thead>
            <tr>
              <th>
                Gudang
              </th>
              <th>
                Produk
              </th>
              <th>
                Volume
              </th>
              <th>
                Stok Terkena Low Moving
              </th>
              <th>
                Biaya Low Moving Stock (100.000/m<sup>3</sup>/bulan)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(product, index) in data.products"
              :key="product.id"
            >
              <td
                v-if="index === 0"
                :rowspan="index === 0 ? data.products.length : 1"
                class="text-left align-middle"
              >
                {{ data.warehouse_name }}
              </td>
              <td>{{ product.product_name }}</td>
              <td>{{ product.volume }} m<sup>3</sup></td>
              <td>{{ product.low_moving_count }}</td>
              <td>{{ formatToRupiah(product.low_moving_cost) }}</td>
            </tr>
            <tr class="border-b border-gray-200">
              <td
                colspan="4"
                class="text-right bg-gray-100"
              >
                <b>Total Biaya Low Moving Stock</b>
              </td>
              <td>
                {{ formatToRupiah(data.total_low_moving_cost) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div :class="isLoading ? 'mt-4 animate-pulse bg-gray-200 h-[40px] rounded-lg w-[120px] mt-4 float-right' : 'mt-4 float-right'">
      <ButtonBayarTagihan
        v-if="!isLoading"
        :invoice-id="$route.query.invoice_id"
        :ref-id="$route.params.id"
        :from-tagihan="true"
        :variant="isLoading || isError ? 'secondary' : 'primary'"
        button-class="max-w-[150px] w-full"
        :disabled="isLoading || isError || isBeenPaid"
      />
    </div>
  </div>
</template>

<script>
/**
 * Component untuk menampilkan detail tagihan low moving stock
 *
 * Component ini menampilkan detail tagihan low moving stock yang terdiri dari gudang, produk, volume,
 * stok terkena low moving, dan biaya low moving stock. Untuk mendapatkan data detail dibutuhkan data
 * ref_id yang diambil dari query params serta status & invoice_id yang diambil dari query params.
 *
 */
import ButtonBayarTagihan from '../../components/ButtonBayarTagihan.vue'

export default {
  name: 'DetailLowMovingStock',
  components: {
    ButtonBayarTagihan,
  },
  data() {
    return {
      isError: false,
      data: {
        warehouse_name: '',
        products: [],
        total_low_moving_cost: null,
      },
      isLoading: true,
    }
  },
  computed: {
    isBeenPaid() {
      return this.$route.query.status === 'PAID'
    },
  },
  mounted() {
    this.fetchDetail()
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    formatToRupiah(value) {
      if (this.isLoading || this.isError) {
        return ''
      }
      return value ? `${new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)}` : '0'
    },
    fetchDetail() {
      this.isLoading = true
      this.$http_new.get(`/kompack/api/v1/stock-recaps/low-moving-stock/${this.$route.params.id}`).then(res => {
        this.data = res.data.data
      }).catch(err => {
        this.isError = true
        this.$toast_error({ message: 'Gagal mengambil detail tagihan, silahkan coba lagi.', timeout: 5000 })
      }).finally(() => {
        this.isLoading = false
      })
    },
  },
}
</script>

<style scoped>
.table-container {
    overflow-x: auto;
}
.table-container__loading {
    width: 100%;
    height: 250px;
    background-color: #f0f0f0;
    border-radius: 10px;
}
table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    color: #2c2c2c;
}
table th, table td {
    padding: 16px;
    text-align: left;
    min-width: 150px;
}
table th {
    padding: 20px 16px;
    color: #2c2c2c;
    font-weight: 500;
    font-size: 14px;
    text-transform: unset;
    vertical-align: middle;
}
@keyframes pulse {
    0% {
        opacity: 0.5;
    }
    50% {
        opacity: 1;
    }
}
@media (max-width: 768px) {
    .detail-item {
        flex-direction: column;
        align-items: start;
        justify-content: start;
    }
    .detail-item__label {
        max-width: 100%;
        width: 100%;
        justify-content: flex-start;
    }
}
</style>
